import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Pokud bude nějaká důležitá změna v programu nebo nějaká jiná důležitá zpráva, tak ti můžeme poslat notifikaci.", -1)

import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from '@ionic/vue'

import { useNotificationsStore } from '@/store/notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsBanner',
  props: {
    eventId: {}
  },
  setup(__props: any) {

const $store = useNotificationsStore()

const props = __props
const topic = `event.${props.eventId}.important`
const isTopicSubscribed = $store.isTopicSubscribed(topic)

return (_ctx: any,_cache: any) => {
  return (_unref($store).isSupported() && !_unref(isTopicSubscribed))
    ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Zapni si notifikace")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(IonButton), {
            fill: "clear",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref($store).registerNotifications(topic)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Zapnout")
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})